/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MiscellaneousSpec } from './miscellaneousSpec';
import { DpxCapabilitySpec } from './dpxCapabilitySpec';
import { CspNotificationsCapabilitySpec } from './cspNotificationsCapabilitySpec';
import { CommerceCapabilitySpec } from './commerceCapabilitySpec';
import { GlobalAccessCapabilitySpec } from './globalAccessCapabilitySpec';
import { DeploymentsCapabilitySpec } from './deploymentsCapabilitySpec';
import { RansomwareCapabilitySpec } from './ransomwareCapabilitySpec';
import { AuditCapabilitySpec } from './auditCapabilitySpec';
import { ResourceOrgCapabilitySpec } from './resourceOrgCapabilitySpec';
import { OrgCapabilitiesRollout } from './orgCapabilitiesRollout';
import { SubscriptionsCapabilitySpec } from './subscriptionsCapabilitySpec';
import { RWRCapabilitiesCrowdstrike } from './rWRCapabilitiesCrowdstrike';
import { SddcManagementSpec } from './sddcManagementSpec';
import { SfdcCapabilitySpec } from './sfdcCapabilitySpec';
import { DeploymentsUpgradeCapabilitySpec } from './deploymentsUpgradeCapabilitySpec';


export interface CapabilitiesSpec { 
    audit?: AuditCapabilitySpec;
    commerce?: CommerceCapabilitySpec;
    crowdstrike_rwr?: RWRCapabilitiesCrowdstrike;
    csp_notifications?: CspNotificationsCapabilitySpec;
    deployments?: DeploymentsCapabilitySpec;
    deployments_upgrade?: DeploymentsUpgradeCapabilitySpec;
    dpx?: DpxCapabilitySpec;
    global_access?: GlobalAccessCapabilitySpec;
    miscellaneous?: MiscellaneousSpec;
    ransomware?: RansomwareCapabilitySpec;
    resource?: ResourceOrgCapabilitySpec;
    sfdc?: SfdcCapabilitySpec;
    subscriptions?: SubscriptionsCapabilitySpec;
    sddc_management?: SddcManagementSpec;
    rollouts?: OrgCapabilitiesRollout;
}

